import React from 'react';
import styled from 'styled-components';
import { H2, Paragraph, Italic, H5 } from './typography';
import {
  TrianglesBottomRight,
  TrianglesTopLeft,
  TrianglesTopRight,
} from './Triangles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 50em;
  padding: 5em 2em;
  margin: auto;

  align-items: center;
  overflow: hidden;
  white-space: normal;
  text-align: justify;
  > h2 {
    text-align: center;
  }

  > h5 {
    text-align: center;
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
`;

const TextSlide = ({
  title,
  subtitle,
  children,
  style,
  hideLeft,
  hideRight,
  atTop,
}) => (
  <Container>
    <Content style={style}>
      {title && <H2>{title}</H2>}
      {subtitle && (
        <Italic>
          <H5>{subtitle}</H5>
        </Italic>
      )}
      <Paragraph style={{ whiteSpace: 'pre-line' }}>{children}</Paragraph>
    </Content>
    {!hideLeft && <TrianglesTopLeft />}
    {!hideRight ? (
      !atTop ? (
        <TrianglesBottomRight />
      ) : (
        <TrianglesTopRight />
      )
    ) : null}
  </Container>
);

export default TextSlide;
